module.exports = __webpack_public_path__ + "img/B2.264d79b3.jpg";